import withWrappers from 'hocs/ReactKeyProvider';
import Shop from './Shop';

export default withWrappers(Shop);
